// extracted by mini-css-extract-plugin
export default {"img":"ArticlesList_img__hkLxj"};